import { ZardDropdownMenuItemComponent } from '@/styles/components/dropdown/dropdown-item.component'
import { ZardDropdownMenuContentComponent } from '@/styles/components/dropdown/dropdown-menu-content.component'
import { ZardDropdownDirective } from '@/styles/components/dropdown/dropdown-trigger.directive'
import { ZardDropdownMenuComponent } from '@/styles/components/dropdown/dropdown.component'
import { ZardMenuLabelComponent } from '@/styles/components/menu/menu-label.component'

export const ZardDropdownImports = [
    ZardDropdownMenuComponent,
    ZardDropdownMenuItemComponent,
    ZardMenuLabelComponent,
    ZardDropdownMenuContentComponent,
    ZardDropdownDirective,
] as const
